/***
 * /////////////////////////////////////////////////////////////////
 * CONSTANTS (定数）
 * ----------------------------
 *
 * TYPEではないserviceContractsに関連するすべての定数について
 * 例を挙げると
 * API エンドポイント
 * /////////////////////////////////////////////////////////////////
 *
 */
export const GET_USERS_API_PATH = "/accounts/{UID}/users/";
export const UNLOCK_AUTH0_USER_API_PATH = "/accounts/{UID}/users/{UUID}/unlock"
export const RESEND_AUTH0_USER_VERIFY_API_PATH = "/accounts/{UID}/users/{UUID}/verify"
